'use es6';

let _ = t => t,
  _t,
  _t2;
import { Global } from '@emotion/react';
import { jsx } from 'react/jsx-runtime';

// src/css-reset.tsx
var vhPolyfill = String.raw(_t || (_t = _`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`));
var CSSPolyfill = () => /* @__PURE__ */jsx(Global, {
  styles: vhPolyfill
});
var CSSReset = ({
  scope = ""
}) => /* @__PURE__ */jsx(Global, {
  styles: String.raw(_t2 || (_t2 = _`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${0} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${0} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${0} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${0} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${0} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${0} :where(b, strong) {
        font-weight: bold;
      }

      ${0} small {
        font-size: 80%;
      }

      ${0} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${0} sub {
        bottom: -0.25em;
      }

      ${0} sup {
        top: -0.5em;
      }

      ${0} img {
        border-style: none;
      }

      ${0} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${0} :where(button, input) {
        overflow: visible;
      }

      ${0} :where(button, select) {
        text-transform: none;
      }

      ${0} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${0} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${0} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${0} progress {
        vertical-align: baseline;
      }

      ${0} textarea {
        overflow: auto;
      }

      ${0} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${0} input[type="number"]::-webkit-inner-spin-button,
      ${0} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${0} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${0} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${0} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${0} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${0} details {
        display: block;
      }

      ${0} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${0} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${0} button {
        background: transparent;
        padding: 0;
      }

      ${0} fieldset {
        margin: 0;
        padding: 0;
      }

      ${0} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${0} textarea {
        resize: vertical;
      }

      ${0} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${0} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${0} table {
        border-collapse: collapse;
      }

      ${0} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${0} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${0} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${0} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${0} select::-ms-expand {
        display: none;
      }

      ${0}
    `), scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, scope, vhPolyfill)
});
var css_reset_default = CSSReset;
export { CSSPolyfill, CSSReset, css_reset_default as default };